import {
    SaveSplitIOMultiValueTargettingRulesAction,
    SplitIOMultiValueTargettingRulesActionType,
} from '../actions/splitioMultiValueTargettingRules';
import { SplitioMultiValueTargetingRulesNamespace } from '../state/splitioMultiValueTargetingRules';

export const splitioMultiValueTargetingRulesReducer = (
    state: SplitioMultiValueTargetingRulesNamespace = {},
    action: SaveSplitIOMultiValueTargettingRulesAction,
): SplitioMultiValueTargetingRulesNamespace => {
    switch (action.type) {
        case SplitIOMultiValueTargettingRulesActionType.saveSplitIOMultiValueTargettingRules: {
            return {
                ...state,
                ...action.payload,
            };
        }
        default:
            return state;
    }
};
